import { render, staticRenderFns } from "./UserProfileAvatar.vue?vue&type=template&id=dccd16d8&scoped=true"
import script from "./UserProfileAvatar.vue?vue&type=script&lang=js"
export * from "./UserProfileAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserProfileAvatar.vue?vue&type=style&index=0&id=dccd16d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccd16d8",
  null
  
)

export default component.exports